import AvatarCircle from 'components/Common/AvatarCircle/AvatarCircle'
import FormatCurrency from 'components/Common/FormatCurrency'
import TextButton from 'components/Luxkit/Button/TextButton'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import React from 'react'
import styled from 'styled-components'

const LuxuryCaption = styled(Caption)`
  color: ${props => props.theme.palette.product.loyalty};
`

export const LoyaltyAvatarCircle = styled(AvatarCircle)`
  background-color: ${(props) => props.theme.palette.product.loyalty};
  border-color: ${(props) => props.theme.palette.product.loyalty};
`

interface Props {
  firstName?: string;
  lastName?: string;
  hasNotification?: boolean;
  balance: number;
}

function LuxuryPlusAccountButton(props: Props) {
  const { firstName, lastName, hasNotification, balance } = props

  return <TextButton
  kind="tertiary"
  to="/account"
  variant="dark"
  aria-label="LuxuryPlus+"
  startIcon={ <LoyaltyAvatarCircle
    size="small"
    firstName={firstName}
    lastName={lastName}
    hasNotification={hasNotification}
    nonInteractable
  />}
>
    <Group direction="vertical" gap={2} horizontalAlign="start">
      <LuxuryCaption variant="medium" weight="bold">LuxuryPlus+</LuxuryCaption>
      {balance > 0 &&
        <Caption variant="medium" colour="primary-dark">
          <FormatCurrency value={balance} format="dynamicDollar" />
        </Caption>
      }
    </Group>
  </TextButton>
}

export default LuxuryPlusAccountButton
